<template>
  <div>
    <div class="add">
      <div class="left"></div>
      <div class="right" @click="clickAddKey">
        <i class="el-icon-plus iAdd"></i>
        <div class="text">添加企业对接</div>
      </div>
    </div>
    <!-- table表单 -->
    <div class="table">
      <el-table
        ref="multipleTable"
        @sort-change="changeTableSort"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        :header-cell-style="{ background: '#fff', color: '#333333' }"
      >
        <el-table-column label="序号" align="center" type="index" width="80"> </el-table-column>
        <el-table-column label="时间" align="center">
          <template slot-scope="scope">
            <div>
              {{ scope.row.time }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="方式" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.way == 0">微信</div>
            <div v-if="scope.row.way == 1">电话</div>
            <div v-if="scope.row.way == 2">视频</div>
            <div v-if="scope.row.way == 3">线下见面</div>
          </template>
        </el-table-column>
        <el-table-column label="人物姓名" align="center">
          <template slot-scope="scope">
            <div>
              {{ scope.row.figureName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="岗位" align="center">
          <template slot-scope="scope">
            <div>{{ scope.row.post }}</div>
          </template>
        </el-table-column>
        <el-table-column label="电话" align="center">
          <template slot-scope="scope">
            <div>{{ scope.row.phone }}</div>
          </template>
        </el-table-column>
        <el-table-column label="微信" align="center">
          <template slot-scope="scope"
            ><div>
              {{ scope.row.weChat }}
            </div></template
          >
        </el-table-column>
        <el-table-column label="邮箱" align="center">
          <template slot-scope="scope">
            <div>
              {{ scope.row.email }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="创建时间" sortable="custom" align="center">
          <template slot-scope="scope">
            <div>
              {{ scope.row.createTime }}
            </div>
          </template>
        </el-table-column>
        <el-table-column sortable="custom" prop="最近更新时间" label="更新时间" align="center">
          <template slot-scope="scope">
            <div>
              {{ scope.row.updateTime }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <div class="operation">
              <div class="compile" @click="clickCompileKey(scope.row)">编辑</div>
              <div class="remove" @click="clickRemoveKey(scope.row)">删除</div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页器 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="query.baseParam.pageNum"
        :page-sizes="[10, 30, 50]"
        :page-size="query.baseParam.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- 对话框区域 -->
    <div class="dialog">
      <el-dialog @close="dialogClose" :visible.sync="dialogVisible" width="750px">
        <div class="dialogHead">
          <div class="line"></div>
          <div class="txt" v-if="echo == 0">添加企业对接</div>
          <div class="txt" v-else>编辑企业对接</div>
        </div>
        <div class="form">
          <el-form ref="form" :model="form" :rules="rules">
            <el-form-item prop="time" label="时间：" label-width="157px">
              <el-date-picker
                v-model="form.time"
                prefix-icon="el-icon-date"
                type="datetime"
                placeholder="选择日期"
                style="width: 238px"
                value-format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
            </el-form-item>

            <!-- 基本信息 -->
            <div class="basicInformation" v-for="(item, index) in form.formList" :key="item.id">
              <div class="each_item">
                <el-form-item
                  :rules="rules.figureName"
                  :prop="'formList.' + index + '.figureName'"
                  label="人物姓名："
                  label-width="93px"
                  style="margin-bottom: 0"
                >
                  <el-input v-model="item.figureName" placeholder="请输入姓名"></el-input>
                </el-form-item>
                <el-form-item
                  prop="post"
                  label="岗位："
                  label-width="93px"
                  style="margin-bottom: 0"
                >
                  <el-input v-model="item.post" placeholder="请输入岗位"></el-input>
                </el-form-item>

                <div class="addItem" @click="clickAddItem" v-if="echo != 1">
                  <i class="el-icon-circle-plus-outline addIcon"></i>
                  <span class="addText">添加</span>
                </div>

                <div class="removeItem" @click="clickRemoveItem(item.id)" v-if="item.id != 0">
                  <i class="el-icon-circle-plus-outline removeIcon"></i>
                  <span class="removeText">移除</span>
                </div>
              </div>
              <div class="each_item">
                <el-form-item
                  prop="phone"
                  label="电话："
                  label-width="93px"
                  style="margin-bottom: 0"
                >
                  <el-input v-model="item.phone" placeholder="请输入电话"></el-input>
                </el-form-item>
                <el-form-item
                  prop="weChat"
                  label="微信："
                  label-width="93px"
                  style="margin-bottom: 0"
                >
                  <el-input v-model="item.weChat" placeholder="请输入微信"></el-input>
                </el-form-item>
              </div>
              <div class="each_item">
                <el-form-item
                  prop="email"
                  label="邮箱："
                  label-width="93px"
                  style="margin-bottom: 0"
                >
                  <el-input v-model="item.email" placeholder="请输入邮箱"></el-input>
                </el-form-item>
              </div>
              <div class="each_item">
                <el-form-item
                  :prop="'formList.' + index + '.way'"
                  :rules="rules.way"
                  label="方式："
                  label-width="93px"
                  style="margin-bottom: 0"
                >
                  <el-radio-group v-model="item.way">
                    <el-radio :label="0">微信</el-radio>
                    <el-radio :label="1">电话</el-radio>
                    <el-radio :label="2">视频</el-radio>
                    <el-radio :label="3">线下见面</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </div>
          </el-form>

          <div class="button">
            <div class="add" @click="clickAddMsg" v-if="echo == 0">添加</div>
            <div class="add" @click="clickAddMsg" v-if="echo == 1">保存</div>
            <div class="cancel" @click="dialogVisible = false">取消</div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {
  getClueScheduleTime,
  getDocking,
  saveDocking,
  updateDocking,
  deleteDocking
} from '@/api/businessCenter.js'

const defaultFormObj = Object.freeze({
  clueCode: '',
  createName: '',
  createTime: '',
  id: 0,
  time: '',
  updateName: '',
  updateTime: '',
  formList: [
    {
      figureName: null, // 人物姓名
      post: null, // 岗位
      phone: null, // 电话
      weChat: null, // 微信
      email: null, // 邮箱
      way: null, // 方式
      id: 0
    }
  ],
  tableItemId: null // 编辑保存的时候需要用到的id
})

export default {
  components: {},
  data() {
    //这里存放数据
    return {
      total: 0,
      tableData: [],
      //一览和详情为一个接口，请求参数中有id时为详情
      query: {
        baseParam: {
          pageNum: 1,
          pageSize: 10
        },
        clueCode: '',
        id: null,
        order: 'desc',
        orderType: '0'
      },
      row: {},
      form: { ...defaultFormObj },

      // 弹框
      dialogVisible: false,
      echo: null,
      // 表单验证
      rules: {
        time: [{ required: true, message: '请选择时间', trigger: 'blur' }],
        figureName: [{ required: true, message: '请输入人物姓名', trigger: 'blur' }],
        way: [{ required: true, message: '请选择方式', trigger: 'blur' }]
      }
    }
  },

  computed: {},

  watch: {},
  created() {
    let row1 = sessionStorage.getItem('row1')
    this.row = JSON.parse(row1)
    this.query.clueCode = this.row.clueCode
    this.search()
  },

  methods: {
    // 进度时间
    async clueScheduleTime() {
      const { data: res } = await getClueScheduleTime({
        clueCode: this.row.clueCode
      })
      if (res.resultCode == 200) {
        this.clueScheduleTimeObj = res.data
        this.active = res.data.order + 1
      }
    },
    async search() {
      const { data: res } = await getDocking(this.query)
      if (res.resultCode == 200) {
        this.tableData = res.data.list
        this.total = res.data.total
        this.$emit('quantity', res.data.total)
      }
    },
    // 表格排序
    changeTableSort(column) {
      if (column.order == 'ascending') {
        this.query.order = 'asc'
      } else if (column.order == 'descending') {
        this.query.order = 'desc'
      }
      if (column.prop == '创建时间') {
        this.query.orderType = 0
      } else if (column.prop == '更新时间') {
        this.query.orderType = 1
      }
      this.search()
    },
    // 添加企业对接
    clickAddKey() {
      this.echo = 0
      this.dialogVisible = true
    },
    // 编辑企业对接
    async clickCompileKey(row) {
      this.echo = 1
      this.dialogVisible = true
      this.query.id = row.id
      this.tableItemId = row.id
      const { data: res } = await getDocking(this.query)
      if (res.resultCode == 200) {
        this.form.time = res.data.list[0].time
        this.form.createTime = res.data.list[0].createTime
        this.form.formList[0].figureName = res.data.list[0].figureName
        this.form.formList[0].post = res.data.list[0].post
        this.form.formList[0].phone = res.data.list[0].phone
        this.form.formList[0].weChat = res.data.list[0].weChat
        this.form.formList[0].email = res.data.list[0].email
        this.form.formList[0].way = res.data.list[0].way * 1
        this.form.formList[0].id = 0
        this.query.id = null
      }
    },
    // 删除关键人
    async clickRemoveKey(row) {
      const { data: res } = await deleteDocking({ id: row.id })
      console.log(res)
      if (res.resultCode == 200) {
        this.$message.success('删除成功')
        this.search()
      }
      console.log('删除')
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`)
      this.query.baseParam.pageSize = val
      this.search()
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`)
      this.query.baseParam.pageNum = val
      this.search()
    },
    //获取当前时间并格式化
    initDay() {
      const date = new Date() // 得到当前时间
      const year = date.getFullYear() // 年
      const mont = date.getMonth() + 1 // 月
      const dat = date.getDate() // 日
      const hour = date.getHours() // 时
      const minute = date.getMinutes() // 分
      const second = date.getSeconds() // 秒
      const monts = mont < 10 || mont === 0 ? '0' + mont : mont // 月
      const dats = dat < 10 || dat === 0 ? '0' + dat : dat // 日
      const hours = hour < 10 || hour === 0 ? '0' + hour : hour // 时
      const minutes = minute < 10 ? '0' + minute : minute // 分
      const seconds = second < 10 ? '0' + second : second // 秒
      return `${year}-${monts}-${dats} ${hours}:${minutes}:${seconds}`
    },
    // dialog 关闭的回调
    dialogClose() {
      // 新增的关闭
      this.form = { ...defaultFormObj }
      this.form.formList = [
        {
          figureName: null, // 人物姓名
          post: null, // 岗位
          phone: null, // 电话
          weChat: null, // 微信
          email: null, // 邮箱
          way: null, // 方式
          id: 0
        }
      ]
      this.form.time = ''
    },
    // 填写完信息后的添加按钮
    clickAddMsg() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.echo == 0) {
            // 新增
            let arr = [] //请求传的数组
            this.form.formList.map(async (item) => {
              let obj = {
                clueCode: this.row.clueCode,
                createName: this.row.createName,
                createTime: this.initDay(),
                email: item.email,
                figureName: item.figureName,
                id: 0,
                phone: item.phone,
                post: item.post,
                time: this.form.time,
                updateName: null,
                updateTime: this.initDay(),
                way: item.way,
                weChat: item.weChat
              }
              arr.push(obj)
            })
            const { data: res } = await saveDocking(arr)
            if (res.resultCode === 200) {
              this.$message.success('新增成功！')
              this.form = { ...defaultFormObj }
              this.search()
              this.dialogVisible = false
            } else {
              this.$message.error('新增失败！')
            }
          } else if (this.echo == 1) {
            //编辑
            let obj = {
              clueCode: this.row.clueCode,
              createName: this.row.createName,
              createTime: this.form.createTime,
              email: this.form.formList[0].email,
              figureName: this.form.formList[0].figureName,
              id: this.tableItemId,
              phone: this.form.formList[0].phone,
              post: this.form.formList[0].post,
              time: this.form.time,
              updateName: null,
              updateTime: this.initDay(),
              way: this.form.formList[0].way,
              weChat: this.form.formList[0].weChat
            }
            const { data: res } = await updateDocking(obj)
            if (res.resultCode == 200) {
              this.search()
              this.dialogVisible = false
              this.$message.success('编辑成功！')
              this.form = { ...defaultFormObj }
            } else {
              this.$message.error('编辑失败！')
            }
          }
        }
      })
    },
    // 点击添加每一项的人物信息
    clickAddItem() {
      this.form.formList.push({
        figureName: null, // 人物姓名
        post: null, // 岗位
        phone: null, // 电话
        weChat: null, // 微信
        email: null, // 邮箱
        way: null, // 方式
        id: this.form.formList.length
      })
    },
    // 移除
    clickRemoveItem(id) {
      this.form.formList.forEach((item) => {
        if (item.id == id) {
          this.form.formList.splice(item.id, 1)
        }
      })
      this.form.formList.forEach((item, index) => {
        this.form.formList[index].id = index
      })
    }
  },

  mounted() {}
}
</script>
<style scoped lang="less">
.add {
  height: 60px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 87px;
  .right {
    background-color: #17757a;
    border-radius: 4px;
    width: 108px;
    height: 32px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    cursor: pointer;
    .text {
      margin-left: 3px;
    }
    .iAdd {
      transform: translateY(1px);
    }
  }
}
.table {
  box-sizing: border-box;
  background-color: #fff;

  .operation {
    display: flex;
    justify-content: space-around;
    .compile {
      font-size: 12px;
      font-weight: 400;
      color: #17757a;
      cursor: pointer;
    }
    .remove {
      font-size: 12px;
      font-weight: 400;
      color: #fa5050;
      cursor: pointer;
    }
  }
}
/deep/.el-dialog__header {
  padding: 0;
}
/deep/.el-dialog__body {
  padding: 0 0 30px 0px;
}
.pagination {
  width: 100%;
  height: 120px;
  background-color: #fff;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dialogHead {
  display: flex;
  align-items: center;
  height: 54px;
  padding-left: 16px;
  .line {
    width: 4px;
    height: 20px;
    background-color: #17757a;
    border-radius: 2px;
    margin-right: 8px;
  }
  .txt {
    color: #333333;
    font-size: 16px;
    font-weight: 500;
  }
}
.dialog {
  /deep/.el-input {
    width: 175px;
  }

  .basicInformation {
    margin-left: 66px;
    box-sizing: border-box;
    padding: 15px 0;
    width: 675px;
    border-radius: 4px;
    background-color: #fbfbfb;
    margin-bottom: 20px;

    .each_item {
      display: flex;
      height: 40px;
      margin-bottom: 20px;

      /deep/.el-radio__inner {
        width: 18px;
        height: 18px;
      }
      /deep/.el-radio__label {
        padding-left: 6px;
      }
    }
    .addItem {
      display: flex;
      align-items: center;
      cursor: pointer;
      .addIcon {
        font-size: 16px;
        color: #17757a;
        margin: 0 6px 0 17px;
      }
      .addText {
        font-size: 14px;
        color: #17757a;
      }
    }

    .removeItem {
      display: flex;
      align-items: center;
      cursor: pointer;
      .removeIcon {
        font-size: 16px;
        color: #17757a;
        margin: 0 6px 0 17px;
      }
      .removeText {
        font-size: 14px;
        color: #17757a;
      }
    }
  }
}

.button {
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  .add {
    width: 64px;
    height: 33px;
    border-radius: 4px;
    background-color: #17757a;
    font-size: 12px;
    color: #fff;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    cursor: pointer;
  }
  .cancel {
    width: 64px;
    height: 33px;
    border-radius: 4px;
    border: 1px solid #17757a;
    font-size: 12px;
    color: #17757a;
    font-weight: 400;
    margin-left: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
}
</style>
